import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/pagedList'

export interface PagedProspects extends PagedList<Prospect> {}

export interface Prospect {
  id: string
  companyName: string
  email: string
  firstName: string
  lastName: string
  createdByPba: string
  createdAt: string
  status: number
}

export enum ProspectStatus {
  Completed = 0,
  Deactivated = 1,
  InProgress = 2,
  New = 3,
  ProposalSent = 4,
}

const getProspects = (filter: OrderedPageFilter): Promise<PagedProspects> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: true,
  }

  return adminHttpClient.get('/IchraDecisionTool/Prospects', filter)
}

export default getProspects
